export default {
  SET_TRANSACTIONS(state, payload) {
    state.transactions = payload
  },

  SET_TRANSACTIONS_META(state, payload) {
    state.transactionsMeta = payload
  },

  SET_DEBIT_TRANSACTIONS(state, payload) {
    state.debitTransactions = payload
  },

  SET_CREDIT_TRANSACTIONS(state, payload) {
    state.creditTransactions = payload
  },

  SET_FUTURE_TRANSACTIONS(state, payload) {
    state.futureTransactions = payload
  },

  SET_WALLET_SUMMARY(state, payload) {
    state.walletSummary = payload
  },

  SET_AMOUNT_TO_RECEIVE(state, payload) {
    state.amountToReceive = payload
  },

  SET_CASHBACK_AMOUNT_TO_RECEIVE(state, payload) {
    state.cashbackAmountToReceive = payload
  },

  SET_WALLET_UPDATED_AT(state, payload) {
    state.walletUpdatedAt = payload
  },

  SET_LAST_DRAW(state, payload) {
    state.lastDraw = payload
  },

  SET_EXTERNAL_TOKEN(state, payload) {
    state.externalToken = payload
  },

  SET_TRANSACTIONS_LOADEDS(state, payload) {
    state.transactionsLoadeds = payload
  },

  SET_BONUS_RECEIVED(state, payload) {
    state.bonusReceived = payload
  },

  SET_ACCOUNTS_PIX(state, payload) {
    state.pixKeysAccount = payload
  },

  SET_LIST_PIX_KEY(state, payload) {
    state.listPixKey = payload
  },

  SET_USER_SELECTED(state, payload) {
    state.chosenOwner = payload
  },

  SET_SELECTED_ACCOUNT_TRANFER(state, payload) {
    state.userDataTransfer = payload
  },

  SET_ATTEMPT_REGISTER_PHONE(state, payload) {
    state.attemptRegisterPhone = payload
  },

  SET_CREDITED_PIX_AMOUNT(state, payload) {
    state.pix_amount_credited = payload
  },

  SET_WALLET_DETAILS(state, payload) {
    state.walletDetails = payload
  },

  SET_PHONE_WALLET_INFO(state, payload) {
    state.phoneWalletInfo = payload
  },
}
